/** Display helpers for ticket.tags (TicketTagSummaryResponse[]) on list/report rows. */

export function formatTicketTagsLabel(ticketOrTags, emptyLabel = '—') {
  const tags = Array.isArray(ticketOrTags)
    ? ticketOrTags
    : ticketOrTags?.tags;
  if (!Array.isArray(tags) || tags.length === 0) return emptyLabel;
  const names = tags
    .map((t) => String(t?.tagName || t?.name || '').trim())
    .filter(Boolean);
  return names.length > 0 ? names.join(', ') : emptyLabel;
}
